"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.array.map.js");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// 在这里引入 tea-portal 组件，样式在 style/index.ts 中引入
// import Avatar from '@tencent/tea-portal/lib/Avatar';

// 在这里引入其他组件，样式在 style/index.ts 中引入
// import Button from '../Button';
var NonePanel = function NonePanel(props) {
  var className = props.className,
    style = props.style,
    type = props.type,
    img = props.img,
    _props$ratio = props.ratio,
    ratio = _props$ratio === void 0 ? 2 : _props$ratio,
    title = props.title,
    desc = props.desc,
    btns = props.btns,
    responsive = props.responsive,
    center = props.center;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('none-panel');
  var classes = (0, _classnames.default)(prefixCls, className, {
    responsive: responsive
  }, {
    'is-center': center
  });
  var imgRef = (0, _react.useRef)(null);
  var initedRef = (0, _react.useRef)(false);
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  (0, _react.useEffect)(function () {
    var img = imgRef.current;
    if (!initedRef.current && img) {
      initedRef.current = true;
      img.onload = function () {
        setWidth(Number(getComputedStyle(img).width.replace('px', '')) / ratio);
      };
    }
  });
  if (type === 'table') {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(classes, "".concat(prefixCls, "--table")),
      style: style
    }, desc && /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "__desc")
    }, desc));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    style: style
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: img,
    alt: "",
    className: (0, _classnames.default)("".concat(prefixCls, "__img"), {
      'is-hidden': !width
    }),
    style: {
      width: width || ''
    },
    ref: imgRef
  }), title && /*#__PURE__*/_react.default.createElement("h3", {
    className: "".concat(prefixCls, "__title")
  }, title), desc && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__desc")
  }, desc), btns && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__btns")
  }, btns.map(function (btn, index) {
    return /*#__PURE__*/_react.default.cloneElement(btn, {
      key: index
    });
  })));
};
var _default = NonePanel;
exports.default = _default;